import { Controller } from '@hotwired/stimulus';
import SignaturePad from 'signature_pad';

export default class extends Controller {
  static targets = ['canvas', 'input'];

  static values = { scrollIntoView: Boolean };

  connect() {
    this.signaturePad = new SignaturePad(this.canvasTarget);
    this.resizeCanvas = this.resizeCanvas.bind(this);
    window.addEventListener('resize', this.resizeCanvas);
    this.resizeCanvas();

    if (this.scrollIntoViewValue) {
      this.element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  disconnect() {
    window.removeEventListener('resize', this.resizeCanvas);
    this.signaturePad.off();
  }

  resizeCanvas() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const data = this.signaturePad.toData();

    this.canvasTarget.width = this.canvasTarget.offsetWidth * ratio;
    this.canvasTarget.height = this.canvasTarget.offsetHeight * ratio;
    this.canvasTarget.getContext('2d').scale(ratio, ratio);

    if (data.length > 0) {
      this.signaturePad.fromData(data);
    } else if (this.inputTarget.value) {
      this.signaturePad.fromDataURL(this.inputTarget.value);
    }
  }

  clear() {
    this.signaturePad.clear();
    this.inputTarget.value = '';
  }

  submit(event) {
    if (this.signaturePad.toData().length > 0) {
      this.inputTarget.value = this.signaturePad.toDataURL('image/png');
    }

    if (!this.inputTarget.value) {
      event.preventDefault();
      event.stopPropagation();
      alert('Please draw your signature before signing.');
    }
  }
}
